class Accordion extends $.Widgets {
  constructor(element, options) {
    super();
    this.id = 'accordion';
    this.options = options;
    this.guid = $.guid(this.id);
    this.element = element;
    this.items = $('details', this.element);
    this.summaries = $('summary', this.element);
  }

  /**
   * Opens an item
   * @param {int} index Position of the item to open
   */
  open(index) {
    if (!$(this.items[index]).hasAttr('open')) {
      $(this.summaries[index]).fire('click');
    }
  }

  /**
   * Closes an item
   * @param {int} index Position of the item to close
   */
  close(index, setFocus = true) {
    if ($(this.items[index]).hasAttr('open')) {
      $(this.summaries[index]).fire('click');
      if (setFocus) {
        this.summaries[index].focus();
      }
    }
  }
}

$.fn.accordion = function accordion(options, widgets = []) {
  return this.each((index, elements) => {
    const accordion = new Accordion(elements[index], options);
    widgets.forEach((widget) => {
      accordion.register(widget);
    });
  });
};
